<template>
	<div class="UserInformation">
		<!-- <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    > -->
		<div class="UserInformation_center_div">
			<div class="form_container container">
				<h3>Try NymbleUp for free</h3>
				<div class="UserInformation__content">
					<p class="UserInformation__sub_head">
						Tell us more about your company
					</p>
				</div>
				<form @submit.prevent="goToAccountType">
					<div
						class="form-group1"
						:class="{ 'not-empty1': company_name.length }"
					>
						<input
							v-model="company_name"
							v-validate="'required'"
							type="text"
							class="form-control1"
							name="company_name"
							autocomplete="company_name"
						/>
						<label for="user" class="animated-label1">
							Company Name
						</label>
					</div>
					<span
						v-show="errors.has('company_name')"
						class="text-red-dark text-xs"
					>
						Please Enter Company Name.
					</span>
					<!-- <div v-if="company_name.length > 0">
            <span
              v-if="company_name.length < 5"
              class="text-red-dark text-xs"
            >
              Company Name should be more than 5 characters.
            </span>
          </div> -->
					<div class="form-group1" :class="{ 'not-empty1': selected_country }">
						<!-- <input
							v-model="selected_country"
							v-validate="'required'"
							type="text"
							class="form-control1"
							name="selected_country"
							autocomplete="selected_country"
						/> -->
						<label for="user">
							Country
						</label>
						<el-select
							v-model="selected_country"
							v-validate="'required'"
							filterable
							name="selected_country"
							placeholder="Select"
							autocomplete="new-password"
							class="mt-2"
							@change="getStateByCountry"
						>
							<el-option
								v-for="(item, index) in counrty"
								:key="index"
								:label="item.country"
								:value="item.country"
							>
							</el-option>
						</el-select>
					</div>
					<span
						v-show="errors.has('selected_country')"
						class="text-red-dark text-xs"
					>
						Please Select country.
					</span>
					<!-- <div class="mt-8">
            <label class="typo__label">
              Country
            </label>
            <multiselect
              v-model="selected_country"
              v-validate="'required'"
              :options="options"
              :custom-label="nameWithLang"
              placeholder="Select Country"
              label="name"
              track-by="name"
              name="value"
              class="form-control1"
            />
            <span
              v-show="errors.has('value')"
              class="text-red-dark text-xs"
            >
              Please Enter country.
            </span>
          </div> -->
					<div class="form-group1" :class="{ 'not-empty1': selected_state }">
						<!-- <input
							v-model="selected_country"
							v-validate="'required'"
							type="text"
							class="form-control1"
							name="selected_country"
							autocomplete="selected_country"
						/> -->
						<label for="user">
							State
						</label>
						<el-select
							v-model="selected_state"
							v-validate="'required'"
							filterable
							name="selected_state"
							placeholder="Select"
							autocomplete="new-password"
							class="mt-2"
						>
							<el-option
								v-for="(item, index) in state"
								:key="index"
								:label="item"
								:value="item"
							>
							</el-option>
						</el-select>
					</div>
					<div
						class="form-group1"
						:class="{ 'not-empty1': selected_city.length }"
					>
						<input
							v-model="selected_city"
							v-validate="'required'"
							type="text"
							class="form-control1"
							name="selected_city"
						/>
						<label for="user" class="animated-label1">
							City
						</label>
					</div>
					<span
						v-show="errors.has('selected_city')"
						class="text-red-dark text-xs"
					>
						Please Enter city.
					</span>
					<el-row :gutter="20">
						<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
							<div
								class="form-group1"
								:class="{ 'not-empty1': Address1.length }"
							>
								<input
									v-model="Address1"
									v-validate="'required'"
									autocomplete="new-address"
									type="text"
									class="form-control1"
									name="address"
								/>
								<label for="user" class="animated-label1">
									Address Line 1
								</label>
							</div>
							<span
								v-show="errors.has('address')"
								class="text-red-dark text-xs"
							>
								Please Enter Address
							</span>
						</el-col>
						<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
							<div
								class="form-group1"
								:class="{ 'not-empty1': Address2.length }"
							>
								<input
									v-model="Address2"
									v-validate=""
									type="text"
									autocomplete="new-address2"
									class="form-control1"
									name="address"
								/>
								<label for="user" class="animated-label1">
									Address Line 2(Optional)
								</label>
							</div>
						</el-col>
					</el-row>
					<div class="form-group1" :class="{ 'not-empty1': zip_code.length }">
						<input
							v-model="zip_code"
							v-validate="'required'"
							type="text"
							class="form-control1"
							name="zip_code"
							autocomplete="zip_code"
							maxlength="10"
						/>
						<label for="user" class="animated-label1">
							Zip/Code
						</label>
					</div>
					<span v-show="errors.has('zip_code')" class="text-red-dark text-xs">
						Please Enter Zip/Code.
					</span>
					<div
						class="form-group1"
						:class="{ 'not-empty1': contact_number.length }"
					>
						<input
							v-model="contact_number"
							v-validate="'required'"
							type="text"
							class="form-control1 contact"
							name="contact_number"
							autocomplete="contact_number"
							maxlength="10"
						/>
						<label for="user" class="animated-label1">
							Contact number
						</label>
					</div>
					<span
						v-show="errors.has('contact_number')"
						class="text-red-dark text-xs"
					>
						Please Enter Contact number
					</span>
					<div class="mt-8">
						<label for="user" class="animated-label1">
							Company Type
						</label>
						<div class="mt-2">
							<el-select
								v-model="selected_sector"
								v-validate="'required'"
								name="selected_sector"
								placeholder="Select company Type"
							>
								<el-option
									v-for="sector in companySectors"
									:key="sector.label"
									:label="sector.label"
									:value="sector"
								/>
							</el-select>
							<div v-if="selected_sector.value == 'others'">
								<div
									class="form-group1"
									:class="{ 'not-empty1': other_company_sector.length }"
								>
									<input
										v-model="other_company_sector"
										v-validate="'required'"
										type="text"
										autocomplete="other_company_sector"
										class="form-control1"
										name="other_company_sector"
									/>
									<label for="user" class="animated-label1">
										Please specify your sector
									</label>
								</div>
								<span
									v-show="errors.has('other_company_sector')"
									class="text-red-dark text-xs"
								>
									Please enter your sector
								</span>
							</div>
						</div>
					</div>
					<span
						v-show="errors.has('selected_sector')"
						class="text-red-dark text-xs"
					>
						Please select company sector.
					</span>
					<div class="mt-8">
						<label class="typo__label">
							Financial Calendar
						</label>
						<el-row>
							<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
								<label class="label"> Start Date </label><br />
								<el-date-picker
									v-model="start_date1"
									v-validate="'required'"
									type="date"
									placeholder="Pick a date"
									name="start_date1"
									format="dd-MM-yyyy"
									@change="autoFillEndDate"
								/><br />
								<span
									v-show="errors.has('start_date1')"
									class="text-red-dark text-xs"
								>
									Please Enter start date.
								</span>
							</el-col>
							<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
								<label class="label"> End Date </label><br />
								<el-date-picker
									v-model="end_date1"
									v-validate="'required'"
									type="date"
									placeholder="End date"
									name="end_date"
									format="dd-MM-yyyy"
									value-format="dd-MM-yyyy"
									disabled
								/><br />
								<span
									v-show="errors.has('end_date')"
									class="text-red-dark text-xs"
								>
									Please Enter end date.
								</span>
							</el-col>
						</el-row>
					</div>
					<!-- <div class="UserInformation__content">
            <p class="UserInformation__location_label">
              Do you have more than one store<span class="text-red-dark text-xs">
                *
              </span>
            </p>
          </div>
          <div class="UserInformation__input_section">
            <input
              v-model="is_single_location"
              v-validate="'required'"
              name="location"
              type="radio"
              :value="true"
              autocomplete="is_single_location"
            > <label>Yes</label>
          </div>
          <div class="UserInformation__input_section">
            <input
              v-model="is_single_location"
              v-validate="'required'"
              type="radio"
              name="location"
              autocomplete="is_single_location"
              :value="false"
              @click="clearMoreStore()"
            > <label>No</label>
          </div> -->
					<div class="form-group1" :class="{ 'not-empty1': more_store.length }">
						<input
							v-model="more_store"
							v-validate="'required'"
							type="text"
							name="more_store"
							autocomplete="more_store"
							class="form-control1"
						/>
						<label for="user" class="animated-label1">
							Total number of stores
						</label>
					</div>
					<span v-show="errors.has('more_store')" class="text-red-dark text-xs">
						Please Enter number of stores
					</span>
				</form>
				<div class="UserInformation__btn_section mt-8">
					<button class="mr-2" @click="goToStartFreeTrial()">
						Previous
					</button>
					<button @click="goToAccountType()">
						Next
					</button>
				</div>
			</div>
		</div>
		<!-- </el-dialog> -->
	</div>
</template>

<script>
import { serverAddr } from "../../networkConfig";
import counrty from "./country.js";
// import Multiselect from "vue-multiselect";
export default {
	name: "UserInformation",
	components: {
		// Multiselect
	},
	mixins: [],
	props: [],
	data() {
		return {
			company_name: "",
			counrty: [],
			state: [],
			Address1: "",
			Address2: "",
			zip_code: "",
			contact_number: "",
			start_date: "",
			start_date1: "",
			end_date: "",
			end_date1: "",
			is_single_location: "",
			selected_country: "",
			selected_state: "",
			selected_city: "",
			selected_sector: "",
			other_company_sector: "",
			more_store: "",

			company_name_validation: false,
			options: [
				{ name: "Afghanistan" },
				{ name: "Albania" },
				{ name: "American Samoa" },
				{ name: "Andorra" },
				{ name: "India" }
			],
			dialogVisible: true,
			companySectors: [
				{ value: "cafeteria", label: "Cafeteria" },
				{ value: "fast_food", label: "Fast Food" },
				{ value: "fine_dine_restaurant", label: "Fine Dine Restaurant" },
				{ value: "popup_restaurant", label: "Pop-up Restaurant" },
				{ value: "bakery", label: "Bakery" },
				{ value: "bar", label: "Bar " },
				{ value: "nightclub", label: "Nightclub" },
				{
					value: "quick_service_restaurant",
					label: "Quick Service Restaurant"
				},
				{ value: "dessert_store", label: "Dessert Store" },
				{ value: "cafe", label: "Cafe" },
				{ value: "pizzeria", label: "Pizzeria" },
				{ value: "delivery_joint", label: "Delivery Joint" },
				{ value: "food_truck", label: "Food Truck" },
				{ value: "department_store", label: "Department Store" },
				{ value: "dairy_outlet", label: "Dairy Outlet" },
				{ value: "supermarket", label: "Supermarket" },
				{ value: "speciality_store", label: "Speciality Store" },
				{ value: "mom_pop_store", label: "Mom & Pop Store" },
				{ value: "cloud_kitchen", label: "Cloud Kitchen" },
				{ value: "grocery_store", label: "Grocery Store" },
				{ value: "meat_retailer", label: "Meat Retailer" },
				{ value: "others", label: "Other" }
			]
		};
	},
	computed: {
		userRegistration() {
			return this.$store.state.userRegistration;
		}
	},
	mounted() {
		// EventBus.$on("openAccountType", account_type_model => {
		// 	this.goToAccountType();
		// });
	},
	created() {
		this.counrty = counrty.countries;
		// console.log(counrty.countries);
		(this.company_name = this.userRegistration.company_name),
			(this.Address1 = this.userRegistration.Address1),
			(this.Address2 = this.userRegistration.Address2),
			(this.zip_code = this.userRegistration.zip_code),
			(this.contact_number = this.userRegistration.contact_number),
			(this.start_date = this.userRegistration.start_date),
			(this.start_date1 = this.userRegistration.start_date1),
			(this.end_date = this.userRegistration.end_date),
			(this.is_single_location = this.userRegistration.is_single_location),
			(this.selected_country = this.userRegistration.selected_country),
			(this.selected_state = this.userRegistration.selected_state),
			(this.selected_city = this.userRegistration.selected_city),
			(this.selected_sector = this.userRegistration.selected_sector),
			(this.other_company_sector = this.userRegistration.other_company_sector),
			(this.more_store = this.userRegistration.more_store);

		for (var i = 0; i < this.options.length; i++) {
			if (
				this.options[i].name ==
				this.$store.state.userRegistration.selected_country
			) {
				this.selected_country = {
					name: this.options[i].name
				};
			}
		}
		for (var i = 0; i < this.companySectors.length; i++) {
			if (
				this.companySectors[i].value ==
				this.$store.state.userRegistration.selected_sector
			) {
				this.selected_sector = {
					value: this.companySectors[i].value
				};
			}
		}
	},
	methods: {
		getStateByCountry() {
			console.log("nik", this.selected_country);
			this.selected_state = "";
			for (var i = 0; i < this.counrty.length; i++) {
				if (this.selected_country === this.counrty[i].country) {
					this.state = this.counrty[i].states;
				}
			}
		},
		goToStartFreeTrial() {
			this.$router.push("home").catch(()=>{});
		},

		goToAccountType() {
			this.$validator.validateAll().then(result => {
				console.log("result", result);
				if (result) {
					// this.$store.commit("FilledAllUserInformationData", true);
					var userRegistration = {
						company_name: this.company_name,
						Address1: this.Address1,
						Address2: this.Address2,
						selected_country: this.selected_country,
						selected_state: this.selected_state,
						selected_city: this.selected_city,
						selected_sector: this.selected_sector.value,
						zip_code: this.zip_code,
						contact_number: this.contact_number,
						start_date: this.start_date,
						start_date1: this.start_date1,
						end_date: this.end_date,
						is_single_location: this.is_single_location,
						other_company_sector: this.other_company_sector,
						more_store: this.more_store
					};
					this.$store.commit("appendUserRegistrationDetails", userRegistration);
					this.$store.commit("showAccountType", true);
					this.$store.commit("showUserInformation", false);
					this.$store.commit("showFinishSetup", false);
				}
			});
		},
		autoFillEndDate() {
			// console.log(this.start_date);
			var setdate = new Date(this.start_date1);
			setdate.setDate(setdate.getDate() - 1);
			// console.log(setdate);
			var date = setdate.getDate();
			var month = setdate.getMonth() + 1;
			var year = setdate.getFullYear() + 1;
			var endDate = year + "-" + month + "-" + date;
			this.end_date = endDate;
			this.end_date1 = new Date(endDate);

			var start_date = new Date(this.start_date1).getDate();
			var start_month = new Date(this.start_date1).getMonth() + 1;
			var start_year = new Date(this.start_date1).getFullYear();
			var startDate = start_year + "-" + start_month + "-" + start_date;
			this.start_date = startDate;
		},

		nameWithLang({ name }) {
			return `${name}`;
		},
		clearMoreStore() {
			this.more_store = "";
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./UserInformation.scss";
@import "../../assets/css/variable.scss";
@import url("../../assets/css/multiselect.css");
</style>
<style>
.UserInformation .el-icon-close {
	display: none;
}
.UserInformation .el-dialog {
	/* height: auto; */
	/* max-height: 100%; */
	max-width: 650px;
	width: 680px;
	margin-top: 0 !important;
}
@media screen and (max-width: 700px) {
	.UserInformation .el-dialog {
		width: 90%;
	}
}

.UserInformation .el-dialog__body {
	padding: 0 0 30px 0;
}
.UserInformation .el-dialog__header {
	@apply p-0;
}
.UserInformation .UserInformation_button {
	text-align: right !important;
}
.UserInformation .el-button--primary {
	background-color: #f6b079;
	padding: 13px 12px 11px;
	border-radius: 2px;
	font-size: 15px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	color: #fff;
	border: none;
}
@media screen and (max-width: 576px) {
	.UserInformation .UserInformation_button {
		margin-top: 20px;
		text-align: center !important;
	}
}

/*el-select-box*/

.UserInformation .el-select {
	width: 100%;
}
/* .UserInformation .el-select .el-input.is-focus .el-input__inner {
	border-color: #f6b079;
}
.UserInformation .el-select .el-input__inner:focus {
	border-color: #f6b079;
} */
</style>
